const moment = require("moment");
import {
    IWorkflowNode,
    resourceNameWorkflowNode,
} from "../Entity/IWorkflowNode";
import { IDataProvider } from "motw_core/Data/IDataProvider";

class WorkflowRepository {
    public async GetAllNodesFiltered(
        dataProvider: IDataProvider,
        suffix: string
    ) {
        const nodes = await dataProvider.GetRecordsAsync<IWorkflowNode>(
            resourceNameWorkflowNode + suffix
        );

        return nodes;
    }

    public async GetFavoriteNodes(dataProvider: IDataProvider) {
        return await this.GetAllNodesFiltered(
            dataProvider,
            `?isfavorite=eq.true`
        );
    }

    public async GetNodesMatching(dataProvider: IDataProvider, text: string) {
        return await this.GetAllNodesFiltered(
            dataProvider,
            `?lower_workflownode_name=like.*${text.toLowerCase()}*`
        );
    }

    public async DoesExactNodeExistByName(
        dataProvider: IDataProvider,
        name: string
    ) {
        return (
            (await (
                await this.GetAllNodesFiltered(dataProvider, `?name=eq.${name}`)
            ).length) > 0
        );
    }

    public async DoesExactNodeExistById(
        dataProvider: IDataProvider,
        id: number
    ) {
        return (
            (await (
                await this.GetAllNodesFiltered(dataProvider, `?id=eq.${id}`)
            ).length) > 0
        );
    }

    public async GetMaxNodeId(dataProvider: IDataProvider) {
        const result = await dataProvider.GetRecordsAsync<{
            max_workflownode_id: number;
        }>(`rpc/max_workflownode_id`);

        return result[0]?.max_workflownode_id ?? 0;
    }

    public async GetNodeByNameAsync(dataProvider: IDataProvider, name: string) {
        const result = await this.GetAllNodesFiltered(
            dataProvider,
            `?name=eq.${name}`
        );

        if (!result || result.length === 0) {
            return undefined;
        }

        return result[0];
    }

    public async GetNodeById(dataProvider: IDataProvider, id: number) {
        const result = await this.GetAllNodesFiltered(
            dataProvider,
            `?id=eq.${id}`
        );

        if (result.length === 0) {
            return undefined;
        }

        return result[0];
    }

    public async GetParentNodeAsync(
        dataProvider: IDataProvider,
        rootNode: IWorkflowNode
    ) {
        if (rootNode.id === homeNode.id || rootNode.parentid === homeNode.id) {
            return homeNode;
        }

        const parentNode = await this.GetNodeById(
            dataProvider,
            rootNode.parentid
        );

        return parentNode;
    }

    public async GetIncompleteNodes(dataProvider: IDataProvider) {
        const todayNode = await this.GetNodeByNameAsync(
            dataProvider,
            todayNodeName
        );

        if (!todayNode) {
            return [];
        }

        const children = await dataProvider.GetValueAsync<IWorkflowNode[]>(
            `workflownodes/children?id=${todayNode.id}`
        );

        const incompleteNodes = children.filter(
            (node) =>
                node.id !== todayNode.id && !IsNodeAlreadyComplete(node.name)
        );

        return incompleteNodes;
    }

    public async UpdateNodeInDatabaseAsync(
        node: IWorkflowNode,
        changes: Partial<IWorkflowNode>,
        dataProvider: IDataProvider
    ) {
        const filteredNodesFromDb =
            await dataProvider.GetRecordsAsync<IWorkflowNode>(
                `${resourceNameWorkflowNode}?id=eq.${node.id}`
            );

        let nodeToUpdate = filteredNodesFromDb.find((n) => n.id === node.id);

        if (!nodeToUpdate) {
            nodeToUpdate = homeNode;
        }

        const updatedNode = { ...node, ...changes };

        await dataProvider.UpdateRecordAsync(
            `${resourceNameWorkflowNode}?id=eq.${nodeToUpdate.id}`,
            updatedNode
        );
    }

    public async GetAllChildrenAsync(
        rootNode: IWorkflowNode,
        dataProvider: IDataProvider
    ) {
        var allNodes = await this.GetAllNodesAsync(dataProvider);
        var result: IWorkflowNode[] = [];
        result = this.GetChildrenRecursive(rootNode, allNodes, result);
        return result;
    }

    public async GetAllNodesAsync(dataProvider: IDataProvider) {
        const nodes = await dataProvider.GetRecordsAsync<IWorkflowNode>(
            resourceNameWorkflowNode
        );

        return nodes;
    }

    private GetChildrenRecursive(
        rootNode: IWorkflowNode,
        allNodes: IWorkflowNode[],
        result: IWorkflowNode[]
    ) {
        result.push(rootNode);
        const children = allNodes.filter(
            (node) => node.parentid === rootNode.id
        );

        if (!children.length) {
            return result;
        } else {
            children.forEach((child) => {
                this.GetChildrenRecursive(child, allNodes, result);
            });
        }
        return result;
    }

    public async GetBookOfMindRootNodeAsync(dataProvider: IDataProvider) {
        const workflowNodes = await dataProvider.GetRecordsAsync<IWorkflowNode>(
            resourceNameWorkflowNode
        );

        const rootNode = workflowNodes.find(
            (node) => node.name === fromOthersNodeName
        );

        return rootNode;
    }
}

export const workflowRepository = new WorkflowRepository();

export const homeNode: IWorkflowNode = {
    id: 0,
    name: "Home 🏠",
    parentid: 0,
    memorybox: 0,
    maxchildren: null,
    iscollapsed: true,
    sortorder: null,
    isfavorite: false,
    lastmodifiedtime: moment().local().format(),
    viewchronological: false,
    is_encrypted: false
};

export const todayNodeName = "Today 📥";
export const fromOthersNodeName = `From others 📖`;

export function IsNodeAlreadyComplete(text: string) {
    // Check if has timestamp
    var result = text.match(new RegExp(/.*\s\d+:\d+/, "gi"));
    return result;
}
